import React from 'react';
import { IoSearchOutline } from 'react-icons/io5';

import { ActionIcon, Box, UnstyledButton } from '@mantine/core';

import { SpotlightService } from 'services/SpotlightService';

import cx from './SearchBar.module.scss';

const SearchBar = () => {
    return (
        <UnstyledButton className={cx.search} onClick={SpotlightService.open} visibleFrom="xl">
            <IoSearchOutline size={16} />
            <Box className={cx.placeholder}>Search Everything</Box>
        </UnstyledButton>
    );
};

const SearchBarMobile = () => {
    return (
        <ActionIcon onClick={SpotlightService.open} hiddenFrom="xl" variant="subtle" radius={99} size="lg">
            <IoSearchOutline size={20} />
        </ActionIcon>
    );
};

export { SearchBar, SearchBarMobile };
